import React from 'react';
import { colors, fonts } from '../tokens';

/**
 * StepItem – einzelner Schritt in der ProcessTimeline (Page 3).
 * Active-Steps sind dunkel/orange, inaktive grau.
 */
export const StepItem = ({ icon: Icon, num, title, desc, active = false }) => (
  <div style={{ textAlign: 'center', position: 'relative', zIndex: 1, padding: '0 4px' }}>
    <div
      style={{
        width: '26px',
        height: '26px',
        borderRadius: '50%',
        background: active ? colors.navy : colors.border,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 6px',
        border: `2px solid ${active ? colors.navy : '#CBD5E1'}`,
      }}
    >
      <Icon size={12} color={active ? 'white' : colors.slateLight} strokeWidth={2} />
    </div>
    <p style={{ fontFamily: fonts.display, fontSize: '9.5px', fontWeight: 700, color: colors.navy, marginBottom: '2px' }}>{title}</p>
    <p style={{ fontFamily: fonts.body, fontSize: '8px', color: colors.slateMid, lineHeight: 1.3 }}>{desc}</p>
  </div>
);
